var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel-header panel-header-lg"},[_c('header-chart',{attrs:{"height":300,"data":_vm.chartData,"labels":_vm.chartLabels,"title":_vm.chartTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }